import { _ as _sfc_main } from "./VaVirtualScroller.vue_vue_type_script_lang-7d598bb5.mjs";
import { openBlock, createElementBlock, normalizeClass, normalizeStyle, renderSlot, normalizeProps, guardReactiveProps, createElementVNode, Fragment, renderList, mergeProps } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaVirtualScroller_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "wrapper",
    class: normalizeClass(["va-virtual-scroller", _ctx.wrapperClassComputed]),
    style: normalizeStyle(_ctx.wrapperStyleComputed)
  }, [
    renderSlot(_ctx.$slots, "content", normalizeProps(guardReactiveProps({ containerStyleComputed: _ctx.containerStyleComputed, listStyleComputed: _ctx.listStyleComputed, renderBuffer: _ctx.renderBuffer, uniqueKey: _ctx.uniqueKey, currentListOffset: _ctx.currentListOffset })), () => [
      createElementVNode("div", {
        class: "va-virtual-scroller__container",
        style: normalizeStyle(_ctx.containerStyleComputed)
      }, [
        createElementVNode("div", {
          ref: "list",
          role: "list",
          class: "va-virtual-scroller__list",
          style: normalizeStyle(_ctx.listStyleComputed)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.renderBuffer, (item, index) => {
            return renderSlot(_ctx.$slots, "default", normalizeProps(mergeProps({
              key: _ctx.uniqueKey(item, index)
            }, { item, index: _ctx.renderStartIndex + index })));
          }), 128))
        ], 4)
      ], 4)
    ])
  ], 6);
}
const _VaVirtualScroller = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaVirtualScroller as _
};
//# sourceMappingURL=VaVirtualScroller-5a5b7a82.mjs.map
